import React from "react";
import "./ExplorebyRoles.css";

const ExplorebyRoles = () => {
     
    return (
        <>
            <div className="agentic-ai-container-Roles">
                <div className="agentic-ai-wrap-Roles">
                    <div className="heading-box-Roles">
                        <h2 className="main-headings">Gen AI in TDLC Programs</h2>
                    </div>
                    <p className="overview-content-Roles">
                        The Gen AI in TDLC (Technology Delivery Lifecycle) training is a core enabler to integrate Gen AI into 
                        technology delivery projects, enhancing productivity and creating new Gen AI ways of working. There is 
                        an anticipation of significant growth in Gen AI-based delivery projects. To ensure our practitioners are 
                        prepared, completing this training is essential for future success.
                    </p>
                </div>
                <div class="ai-level-section">
                    <div class="ai-level-box">
                        <h3>Level 1</h3>
                        <p>Digital Course</p>
                    </div>

                    <div class="ai-row">
                        <div class="ai-card ai-top-card">
                            <div class="ai-icon-box" style={{backgroundColor: "#460073"}}>
                                <img src={process.env.PUBLIC_URL + "/images/AIAcademy/delivery-icon.png"} alt="icon" />
                            </div>

                            <div class="ai-dot ai-dot-top"></div>

                            <h4 class="ai-title" style={{color: "#460073"}}>Delivery Practitioner</h4>
                            <p class="ai-subtitle">(CL 12 and above)</p>

                            <div style={{ display: "flex", alignItems: "center", gap: "7px"}}>
                                <img 
                                    style= {{width: "15px", height: "15px"}}
                                    src={process.env.PUBLIC_URL + "/images/AIAcademy/clock-icon.png"}
                                    alt="clock-icon"
                                />
                                <p class="ai-hours"><strong>15.5 Hrs Recommended</strong> + 1.5 Hrs Optional</p>
                            </div>
                            <p className="ai-card-content">
                                <strong>Gen AI Essentials</strong> - AI/ML & Gen AI Overview, LLM models, LLM Transformer arch, Responsible AI, Legal & Security
                            </p>
                            <p className="ai-card-content">
                                <strong>Gen AI Deep dive</strong> - Prompt Engineering, Embeddings, Vector Data Stores, Retrieval Augmentation Generation, Finetuning LLM, Ecosystem Tools Example
                            </p>
                        </div>
                        <div class="ai-card ai-top-card">
                            <div class="ai-icon-box" style={{backgroundColor: "#7500c0"}}>
                                <img src={process.env.PUBLIC_URL + "/images/AIAcademy/automation-icon.png"} alt="icon" />
                            </div>

                            <div class="ai-dot ai-dot-top"></div>

                            <h4 class="ai-title" style={{color: "#7500c0"}}>Automation Architect</h4>
                            <p class="ai-subtitle">(CL 9 and above)</p>

                            <div style={{ display: "flex", alignItems: "center", gap: "7px"}}>
                                <img 
                                    style= {{width: "15px", height: "15px"}}
                                    src={process.env.PUBLIC_URL + "/images/AIAcademy/clock-icon.png"}
                                    alt="clock-icon"
                                />
                                <p class="ai-hours"><strong>20.5 Hrs Recommended</strong> + 2.5 Hrs Optional</p>
                            </div>
                            <p className="ai-card-content">Gen AI Essentials + Gen AI Deep dive + <strong>Automation Architect Essentials</strong></p>
                        </div>
                        <div class="ai-card ai-top-card">
                            <div class="ai-icon-box" style={{backgroundColor: "#a100ff"}}>
                                <img src={process.env.PUBLIC_URL + "/images/AIAcademy/tsl-icon.png"} alt="icon" />
                            </div>

                            <div class="ai-dot ai-dot-top"></div>

                            <h4 class="ai-title" style={{color: "#a100ff"}}>Delivery Lead and TSL</h4>
                            <p class="ai-subtitle">(CL 7 and above)</p>

                            <div style={{ display: "flex", alignItems: "center", gap: "7px"}}>
                                <img 
                                    style= {{width: "15px", height: "15px"}}
                                    src={process.env.PUBLIC_URL + "/images/AIAcademy/clock-icon.png"}
                                    alt="clock-icon"
                                />
                                <p class="ai-hours"><strong>4 Hrs Recommended</strong> + 9 Hrs Optional</p>
                            </div>
                            <p className="ai-card-content"><strong>Gen AI Essentials</strong> + Gen AI Deep dive Optional</p>
                        </div>
                    </div>
                </div>

                <div class="ai-arrow-row">
                    <img src="./images/AIAcademy/arrow-row.png" alt="arrow row" />
                </div>

                <div class="ai-level-section">
                    <div class="ai-level-box ai-level2">
                        <h3>Level 2</h3>
                        <p>Online/ Virtual/ Classroom</p>
                    </div>

                    <div class="ai-row">
                        <div class="ai-card ai-bottom-card">
                        <div class="ai-dot ai-dot-bottom"></div>

                        <h4 class="ai-title" style={{color: "#460073"}}>Delivery Practitioner</h4>

                        <div style={{ display: "flex", alignItems: "center", gap: "7px"}}>
                            <img 
                                style= {{width: "15px", height: "15px"}}
                                src={process.env.PUBLIC_URL + "/images/AIAcademy/clock-icon.png"}
                                alt="clock-icon"
                            />
                            <p class="ai-hours"><strong>9 Hrs</strong> (Online self-paced learning)</p>
                        </div>
                        <p className="ai-card-content">Accenture Assets + Ecosystem Tools Usage, Hands-on for Prompt Engineering, AMS/IMS/AD/SI Custom & Platform use cases, GitHub Co-pilot</p>
                    </div>
                    <div class="ai-card ai-bottom-card">
                        <div class="ai-dot ai-dot-bottom"></div>

                        <h4 class="ai-title" style={{color: "#7500c0"}}>Delivery Practitioner or Delivery Lead and TSL</h4>

                        <div style={{ display: "flex", alignItems: "center", gap: "7px"}}>
                            <img  
                                style= {{width: "15px", height: "15px"}}
                                src={process.env.PUBLIC_URL + "/images/AIAcademy/clock-icon.png"}
                                alt="clock-icon"
                            />
                            <p class="ai-hours"><strong>12 Hrs</strong> (Classroom instructor-led)</p>
                        </div>
                        <p className="ai-card-content">
                            Accenture Assets + Ecosystem Tools, Differentiation, Full Suite vs Lite Options, 
                            Architecture, Legal & Security, Design Patterns, Deployment Models, Installation & Configuration, Pilot Learning, Hands-on
                        </p>
                    </div>
                    <div class="ai-card ai-bottom-card">
                        <div class="ai-dot ai-dot-bottom"></div>

                        <h4 class="ai-title" style={{color: "#a100ff"}}>Delivery Lead and TSL</h4>

                        <div style={{ display: "flex", alignItems: "center", gap: "7px"}}>
                            <img 
                                style= {{width: "15px", height: "15px"}}
                                src={process.env.PUBLIC_URL + "/images/AIAcademy/clock-icon.png"}
                                alt="clock-icon"
                            />
                            <p class="ai-hours"><strong>8 Hrs</strong> (Virtual instructor-led)</p>
                        </div>
                        <p className="ai-card-content">
                            Accenture Assets + Ecosystem Tools, Differentiation, Full Suite vs Lite Options, 
                            Legal & Security, IT Use cases and Productivity, Pilot Leanings, Delivery Execution Guide, 
                            Assessing impact on Contracts, Solution Changes and Commercial Models.
                        </p>
                    </div>
                </div>
            </div>
            <div className="explore-section">
                <div className="explore-content">
                    <img
                        className="link-img"
                        src={process.env.PUBLIC_URL + "/images/AIAcademy/link-icon.png"}
                        alt="link icon">
                    </img>
                    <p className="explore-text">
                        Explore insights and resource on the Gen AI in TDLC microsite. 
                        <a href="https://atci.lkm.delivery.accenture.com/TT/Automation/genAI" target="_blank"  rel="noreferrer" style={{textDecoration: "none"}}>click here</a> to visit.
                    </p>
                </div>
            </div> 
            <div className="heading-box-Roles">
                <h2 className="main-headings">Training Options</h2>
            </div>
            <section class="roles-container">
                <div class="card">
                    <div class="circle" style={{background: "#460073"}}>01</div>
                    <h2 className="section-heading" style={{color: "#460073"}}>Gen AI for Delivery Practitioners</h2>
                    <p class="subtitle">(CL 12 and above)</p>
                    <p class="desc">
                        <strong>For</strong> - 
                        Technology Delivery Practitioners working as Application & Infrastructure Maintenance Analysts, 
                        Service Reliability Engineers, Service Managers, Product Owners, Project Managers, 
                        Business Analysts, Architects & Designers, Developers & Testers, and Full-stack Engineers. 
                    </p>

                    <hr/>

                    <h3>Training Steps</h3>
                    <div class="steps">
                        <div class="step">
                            <div class="step-circle" style={{background: "#460073"}}><span>Step</span><strong>1</strong></div>
                                <div class="step-text">
                                    <p class="step-title">Complete Level 1</p>
                                    <a href="https://wd103.myworkday.com/accenture/learning/program/d67b735c2ae81002f8dff24237510000?type=2d29754fdb8e100008b50ff6bc94003b" target="_blank"  rel="noreferrer">
                                        Gen AI for Delivery Practitioners Level 1
                                    </a>
                                </div>
                            </div>

                            <div class="step">
                                <div class="step-circle" style={{background: "#460073"}}><span>Step</span><strong>2</strong></div>
                                    <div class="step-text">
                                        <p class="step-title">Complete Level 2</p>
                                        <a href="https://wd103.myworkday.com/accenture/learning/course/6789d07206d2100110bde2a5100b0001?type=9882927d138b100019b928e75843018d&record=a079bafc57c59004318d2e5da2740000" target="_blank"  rel="noreferrer">
                                            Gen AI for Delivery Practitioners Level 2
                                        </a>
                                    </div>
                                </div>
                            </div>      
                        </div>

                    <div class="card">
                        <div class="circle" style={{background: "#7500c0"}}>02</div>
                        <h2 className="section-heading" style={{color: "#7500c0"}}>Gen AI for Automation Architects</h2>
                        <p class="subtitle">(CL 9 and above)</p>
                        <p class="desc">
                            <strong>For</strong> - 
                            Technology Automation Architects working on Application & Infrastructure Management, 
                            Application Development, System Integration Programs; focusing on identifying automation 
                            use cases, using Accenture Assets and/or Ecosystem Tools to build new automations and 
                            drive automation journey.
                        </p>

                        <hr/>

                        <h3>Training Steps</h3>
                        <div class="steps">
                            <div class="step">
                                <div class="step-circle" style={{background: "#7500c0"}}><span>Step</span><strong>1</strong></div>
                                    <div class="step-text">
                                    <p class="step-title">Complete Level 1</p>
                                    <a href="https://wd103.myworkday.com/accenture/learning/program/4f612f60a18e1000d2b717dcffc90000?type=2d29754fdb8e100008b50ff6bc94003b"  target="_blank" rel="noreferrer">
                                        Gen AI for Automation Architects
                                    </a>
                            </div>
                        </div>

                        <div class="step">
                            <div class="step-circle" style={{background: "#7500c0"}}><span>Step</span><strong>2A</strong></div>
                            <div class="step-text">
                                <p class="step-title">Complete Level 2A</p>
                                <p>Option 1: 
                                    <a href="https://wd103.myworkday.com/accenture/learning/course/6789d07206d2100110bde2a5100b0001?type=9882927d138b100019b928e75843018d&record=a079bafc57c59004318d2e5da2740000" target="_blank" rel="noreferrer">
                                        Gen AI Level 2A for CL 9 & above
                                    </a>
                                </p>
                                <p>Option 2: 
                                    <a href="https://wd103.myworkday.com/accenture/learning/course/62bab16d9e8b1000d402e7cdc2740001?type=9882927d138b100019b6a2df1a46018b" target="_blank" rel="noreferrer">
                                        Gen AI Level 2A for CL 7 & above
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div class="step">
                            <div class="step-circle" style={{background: "#7500c0"}}><span>Step</span><strong>3</strong></div>
                                <div class="step-text">
                                    <p class="step-title">Complete Level 2B*</p>
                                    <p><a href="https://wd103.myworkday.com/accenture/learning/course/895e6930021e10018439a00449640001?type=9882927d138b100019b6a2df1a46018b" target="_blank" rel="noreferrer">
                                        Non-ATCI (except ATCP & Japan) Classroom & Virtual
                                    </a></p>
                                    <p><a href="https://wd103.myworkday.com/accenture/learning/course/895e6930021e10018439a00449640001?type=9882927d138b100019b6a2df1a46018b" target="_blank" rel="noreferrer">
                                        Non-ATCI (for ATCP & Japan) Classroom only
                                    </a></p>
                                </div>
                            </div>
                            <p class="note">* Available post completion of Level 1 + either Option 1 or Option 2 of Level 2A + nomination from market leads</p>
                        </div>
                    </div>

                    <div class="card">
                        <div class="circle" style={{background: "#a100ff"}}>03</div>
                        <h2 className="section-heading" style={{color: "#a100ff"}}>Gen AI for Delivery Leads and Tech Service Leads</h2>
                        <p class="subtitle">(CL 7 and above)</p>
                        <p class="desc">
                            <strong>For</strong> - 
                            Technology Delivery Leads (Delivery Leads, Contract DL, Portfolio DL), Technology Service Leads (TSLs), and Emerging TSLs.
                        </p>

                        <hr/>

                        <h3>Training Steps</h3>
                        <div class="steps">
                            <div class="step">
                                <div class="step-circle" style={{background: "#a100ff"}}><span>Step</span><strong>1</strong></div>
                                <div class="step-text">
                                    <p class="step-title">Complete Level 1</p>
                                    <a href="https://wd103.myworkday.com/accenture/learning/program/72a13c7a98391002f96960be898b0000?type=2d29754fdb8e100008b50ff6bc94003b" target="_blank" rel="noreferrer">
                                        Gen AI for Delivery Leads and Tech Services Leads Level 1
                                    </a>
                                </div>
                            </div>

                            <div class="step">
                                <div class="step-circle" style={{background: "#a100ff"}}><span>Step</span><strong>2</strong></div>
                                <div class="step-text">
                                    <p class="step-title">Complete Level 2</p>
                                    <a href="https://wd103.myworkday.com/accenture/learning/course/62bab16d9e8b1000d402e7cdc2740001?type=9882927d138b100019b6a2df1a46018b" target="_blank" rel="noreferrer">
                                        Gen AI for Delivery Leads and Tech Services Leads Level 2
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ExplorebyRoles;